export const BLOG_POST_COVER_IMAGE_MAX_WIDTH = 1800;
export const BLOG_POST_COVER_IMAGE_MAX_HEIGHT = 1080;
